import { paths } from '@/lib/routes'
import type { Suggestion } from '@/types/api'

/** Where a suggestion leads (D-91); `null` = it fills the search box instead (a product name). */
export function suggestionHref(item: Suggestion): string | null {
  switch (item.kind) {
    case 'collection':
      return paths.collection(item.slug)
    case 'category':
      return `${paths.category(item.slug)}${item.subcategory ? `?sub=${item.subcategory}` : ''}`
    case 'shop':
      return paths.shop(item.slug)
    default:
      return null
  }
}

/** The rows of the open suggestion list, to move between them with the arrow keys. */
export function suggestionRows(): HTMLElement[] {
  return [...document.querySelectorAll<HTMLElement>('#search-suggest [data-suggestion]')]
}
